/* eslint-disable no-prototype-builtins */
const isInit = () => {
  if (typeof Animation === 'undefined') {
    return true
  }
  if (!Animation.prototype.hasOwnProperty('finished')) {
    return true
  }
  if (!document.body.getAnimations) {
    return true
  }
  return false
}
const setPreloadPolyfillTime = (time) => {
  if (typeof window !== 'undefined') {
    window.preload_polyfill_time = time
  }
}

export const InitWebAnimationsJsPolyfill = new Promise((res) => {
  setPreloadPolyfillTime(Date.now())
  if (isInit()) {
    console.log('InitWebAnimationsJsPolyfill ')
    import('web-animations-js/web-animations-next.min.js').then(res)
  } else {
    res(null)
  }
})
